module.exports = __webpack_public_path__ + "c63b508d01604c259351af141fd1996d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icon-ANO-40px-x-40px.png
// module id = 368
// module chunks = 7